import { AdProvider } from "@/types/config.types";

/**
 * Resolve active ad provider from env, with optional runtime override.
 * Runtime override is useful for environments where HTML bootstrapping sets `window.__AD_PROVIDER__`.
 */
export function getAdProvider(): AdProvider {
    const fromWindow =
        typeof window !== "undefined" && typeof (window as any).__AD_PROVIDER__ === "string"
            ? String((window as any).__AD_PROVIDER__)
            : "";
    const raw = (fromWindow || process.env.REACT_APP_AD_PROVIDER || "").trim().toUpperCase();
    if (raw === "RAPTIVE" || raw === "ADSENSE" || raw === "OFF") {
        return raw;
    }
    return "ADSENSE";
}
